module.exports = __webpack_public_path__ + "static/media/slide-2.f54ac57f.png";